/* InheritedFieldUtility.js */

"use strict";

const _ = require("lodash");

class InheritedFieldUtility {
    constructor(field, fieldClass, entity, parentEntity, form, inheritMethod, localValueMethod, siteNameMap) {
        this._field = field;
        this._fieldClass = fieldClass;
        this._entity = entity;
        this._parentEntity = parentEntity;
        this._siteNameMap = siteNameMap;
        this._form = form;
        this._fromFeild = `${field}From`;
        this._inheritMethod = inheritMethod || `setSiteAssigned${_.capitalize(field)}`;
        this._localValueMethod = localValueMethod || `setDirectlyAssigned${_.capitalize(field)}`;

        this._fieldEl = this._form.renderer.rootElement.querySelector("." + this._fieldClass);

        this._inpEl;
    }

    setEntity(val) {
        this._entity = val;
    }

    setParentEntity(val) {
        this._parentEntity = val;
    }

    setSiteNameMap(val) {
        this._siteNameMap = val;
    }

    setForm(val) {
        this._form = val;
    }

    generateIcon() {
        if (!this._parentEntity) {
            return;
        }
        this._fieldEl = this._form.renderer.rootElement.querySelector("." + this._fieldClass);

        if (this._fieldEl.classList.contains("text")) {
            this._inpEl = this._fieldEl.querySelector("input-text-control");
        } else if (this._fieldEl.classList.contains("number")) {
            this._inpEl = this._fieldEl.querySelector("input-number-control");
        } else if (this._fieldEl.classList.contains("boolean")) {
            this._inpEl = this._fieldEl.querySelector("input-checkbox-control");
        } else if (this._fieldEl.classList.contains("enum")) {
            this._inpEl = this._fieldEl.querySelector("gl-multi-select");
        }

        const existingEl = this._fieldEl.querySelector(".inherit-field");
        if(existingEl) {
            existingEl.remove();
        }
        const inheritanceEl = document.createElement("div");
        let titleText = "";

        inheritanceEl.classList.add("inherit-field");
        this._iconEl = document.createElement("base-icon-gl");
        
        if (_.get(this._entity, this._fromFeild)) {
            this._iconEl.dataset.icon = "common.site_inheritnce_off";
            this._iconEl.dataset.inherited = "yes";
            titleText = `Override ${this._siteNameMap[_.get(this._entity, this._fromFeild)]} value`;
            this._inpEl.classList.add("disabled");
        } else {
            this._iconEl.dataset.icon = "siteexplorer.site";
            this._iconEl.dataset.inherited = "no";
            titleText = `Reset to ${this._parentEntity.name} value`;
        }
        this._iconEl.setAttribute("title", titleText);
        inheritanceEl.appendChild(this._iconEl);
        this._fieldEl.appendChild(inheritanceEl);
        this._iconEl.addEventListener("click", this.onInheritanceIconClick = this.onInheritanceIconClick.bind(this));
    }

    updateIconTitle() {
        let titleText = "";
        if (_.get(this._entity, this._fromFeild)) {
            titleText = `Override ${this._siteNameMap[_.get(this._entity, this._fromFeild)]} value`;
        } else {
            titleText = `Reset to ${this._parentEntity.name} value`;
        }
        this._iconEl.setAttribute("title", titleText);
    }

    onInheritanceIconClick() {
        const isInherited = this._iconEl.dataset.inherited;
        const parentName = _.get(this._entity, this._fromFeild) ?
            this._siteNameMap[_.get(this._entity, this._fromFeild)] :
            this._parentEntity.name;
        
        let titleText = "";
        if(isInherited === "no") {
            this._iconEl.dataset.icon = "common.site_inheritnce_off";
            this._iconEl.dataset.inherited = "yes";
            titleText = `Override ${parentName} value`;
            _.invoke(this._entity, this._inheritMethod, this._parentEntity);
            this._inpEl.classList.add("disabled");
        } else if (isInherited === "yes") {
            this._iconEl.dataset.icon = "siteexplorer.site";
            this._iconEl.dataset.inherited = "no";
            titleText = `Reset to ${parentName} value`;
            _.invoke(this._entity, this._localValueMethod, this._parentEntity.discoveryLevel || 1);
            this._inpEl.classList.remove("disabled");
        }
        let formVal = this._form.getValue();
        formVal[this._field] = this._entity[this._field];
        this._form.setPristineValue(formVal);
        this._iconEl.setAttribute("title", titleText);
    }
    // Multi edit
    generateIconMe() {
        this._fieldEl = this._form.renderer.rootElement.querySelector("." + this._fieldClass);

        if (this._fieldEl.classList.contains("text")) {
            this._inpEl = this._fieldEl.querySelector("input-text-control");
        } else if (this._fieldEl.classList.contains("number")) {
            this._inpEl = this._fieldEl.querySelector("input-number-control");
        } else if (this._fieldEl.classList.contains("boolean")) {
            this._inpEl = this._fieldEl.querySelector("input-checkbox-control");
        } else if (this._fieldEl.classList.contains("enum")) {
            this._inpEl = this._fieldEl.querySelector("gl-multi-select");
        }

        const existingEl = this._fieldEl.querySelector(".inherit-field");
        if(existingEl) {
            existingEl.remove();
        }
        const inheritanceEl = document.createElement("div");

        inheritanceEl.classList.add("inherit-field");
        this._iconEl = document.createElement("base-icon-gl");

        this._iconEl.dataset.icon = "siteexplorer.site";
        this._iconEl.dataset.inherited = "no";

        
        inheritanceEl.appendChild(this._iconEl);
        this._fieldEl.appendChild(inheritanceEl);

        // this._iconEl.addEventListener("click", this.onInheritanceIconClickMe = this.onInheritanceIconClickMe.bind(this));

    }

    addEventListenerMe() {
        this._iconEl.setAttribute("title", "Reset to parent site value");
        this._iconEl.classList.add("enabled");
        this._iconEl.addEventListener("click", this.onInheritanceIconClickMe = this.onInheritanceIconClickMe.bind(this));
    }

    removeEventListenerMe() {
        this._iconEl.setAttribute("title", "");
        this._iconEl.classList.remove("enabled");
        this._iconEl.removeEventListener("click", this.onInheritanceIconClickMe);
    }

    onInheritanceIconClickMe() {
        const isInherited = this._iconEl.dataset.inherited;
        let titleText = "";
        if(isInherited === "no") {
            this._iconEl.dataset.icon = "common.site_inheritnce_off";
            this._iconEl.dataset.inherited = "yes";
            this._isInherited = true;
            titleText = `Override parent site value`;
            // _.invoke(this._entity, this._inheritMethod, this._parentEntity);
            this._inpEl.classList.add("disabled");
        } else if (isInherited === "yes") {
            this._iconEl.dataset.icon = "siteexplorer.site";
            this._iconEl.dataset.inherited = "no";
            titleText = `Reset to parent site value`;
            // _.invoke(this._entity, this._localValueMethod, this._parentEntity.discoveryLevel || 1);
            this._inpEl.classList.remove("disabled");
            this._isInherited = false;
        }
        this._iconEl.setAttribute("title", titleText);
    }
}

module.exports = InheritedFieldUtility;